// @flow strict

import * as React from 'react';
import appendScriptOnce from '../util/appendScriptOnce';

type WistiaVideoPropTypes = {
  aspectRatio: '16:9' | '4:3',
  wistiaId: string,
};

const ratioMap = {
  '16:9': '56.25%',
  '4:3': '75%',
};

export default (props: WistiaVideoPropTypes) => {
  React.useEffect(() => {
    appendScriptOnce({
      src: 'https://fast.wistia.com/assets/external/E-v1.js',
      id: 'wistiaScript',
    });
    appendScriptOnce({
      src: `https://fast.wistia.com/embed/medias/${props.wistiaId}.jsonp`,
      id: `wistia-${props.wistiaId}`,
    });
  }, [props.wistiaId]);

  return (
    <div
      className="wistia_responsive_padding"
      style={{ padding: `${ratioMap[props.aspectRatio]} 0 0 0`, position: 'relative' }}
    >
      <div
        className="wistia_responsive_wrapper"
        style={{ height: '100%', left: '0', position: 'absolute', top: '0', width: '100%' }}
      >
        <div
          className={`wistia_embed wistia_async_${props.wistiaId} seo=false videoFoam=true`}
          style={{ height: '100%', width: '100%' }}
        >
          &nbsp;
        </div>
      </div>
    </div>
  );
};
